import React from 'react';
import { checkHasPermissionShipmentTrackingRead } from '../../../utils';
import CancelShipmentButton from './CancelShipmentButton';
import ViewShipmentExternalButton from './ViewShipmentExternalButton';
import Products from './Products';
import TrackingButton from './TrackingButton';
import ShipmentStatus from './ShipmentStatus';

export default ({
  shipment,
  skuFilter,
  updateSbOrderData
}) => {
  const {
    id,
    products,
    status_derived,
  } = shipment

  const hasRead = checkHasPermissionShipmentTrackingRead()

  const isActive = (status_derived !== 'Cancelled')

  return (
    <div>
      <div style={{
        fontSize: '15px',
        fontWeight: 'bold',
        marginBottom: '20px',
        display: 'flex'
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <span>{`Shipment #${id}`}</span>
          <ShipmentStatus shipment={shipment} />
          <TrackingButton shipment={shipment} />
        </div>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'end', gap: '10px', fontSize: '12px' }}>
          <ViewShipmentExternalButton shipment={shipment} />
          {isActive && hasRead &&
            <CancelShipmentButton shipment={shipment} updateSbOrderData={updateSbOrderData} />
          }
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '20px'}}>
        <Products products={products} skuFilter={skuFilter} />
      </div>
    </div>
  )
}